export default {
  date: 'June 27, 2024',
  title: 'Discover the Getfloorplan YouTube Channel!',
  description: 'A valuable resource for everyone interested in real estate',
  id: 'youtube-channel',
  jsx: () => (
    <div class='novelty__text'>
      <p>A valuable resource for everyone interested in real estate.</p>
      <p>On our channel, you'll find a wealth of useful information, news, and reviews to help you stay updated on the latest trends and innovations in the real estate industry.</p>
      <b>What to Expect on Our Channel?</b>
      <br />
      <br />
      <b>Useful Information for Clients</b>
      <ul>
        <li>Learn how to effectively use our floorplans, 3D tours, and visualization services.</li>
        <li>Tips and recommendations for improving your property presentations.</li>
      </ul>
      <b>Real Estate News</b>
      <ul>
        <li>Stay informed about the latest events and changes in the real estate market.</li>
        <li>Analysis and forecasts to help you make more informed decisions.</li>
      </ul>
      <b>Style Reviews</b>
      <ul>
        <li>Detailed reviews of various layout and interior styles.</li>
        <li>Ideas and inspiration for your next project.</li>
      </ul>
      <b>Free Webinars</b>
      <ul>
        <li>Join our webinars and learn from the best experts in the industry.</li>
        <li>Get answers to your questions and enhance your skills.</li>
      </ul>
      <b>And Much More Useful Information</b>
      <p>Subscribe to our channel so you don't miss any updates. We regularly publish new videos to help you stay at the forefront of the real estate market and make the most of our services.</p>
      <b>Don't forget to subscribe, hit the bell icon, and stay tuned for updates!</b>
      <p>Join the Getfloorplan community on YouTube and gain access to the most current and useful materials in the real estate industry.</p>
    </div>
  ),
  thumb: 'news/23.webp',
};
